import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot} from '@angular/router';
import {LandingPageService} from "../../data/services/landing-page.service";
import {NavigationCommand, NavigationService} from "../../data/services/navigation.service";

// CanActivate ist als deprecated markiert, deswegen CanActivateFn
/**
 * Dieser Guard überprüft, ob der angeforderte Pfad auf einen externen Link weitergeleitet werden muss.
 */
export const ExternalLinkGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot) => {
  const linkService = inject(LandingPageService);
  const navigationService = inject(NavigationService);

  let actualPath = next.routeConfig?.path;
  const authorizableLinks = Object.values(UrlState);

  // Überprüfen, ob es vielleicht der Link für den nicht authentifizierten Zugriff ist (z. B. 'sub-change-without-login') und durch den entsprechenden Link ersetzen ('sub-change')
  const unauthorizedUrl = authorizableLinks.find(val => val.unauthorized === actualPath);
  if (unauthorizedUrl) {
    actualPath = unauthorizedUrl.authorized;
  }

  // Ist es ein bestehender und gültiger Pfad? (!) Es werden nur aktive Links geliefert => Auswertung vom Status ist obsolet
  linkService.getPageOfUrl(actualPath).subscribe({
    next: ($url) => {
      if ($url && $url.isExtern && $url.externLink) {
        navigationService.navigateExtern($url.externLink, false);
        return false;
      } else if (!$url) {
        // Auf die Startseite weiterleiten, wenn der Link nicht aktiv ist
        navigationService.navigateTo(NavigationCommand.LANDINGPAGE);
        return false;
      }
    }
  });

  // Normale Weiterleitung innerhalb der App
  return true;
}

export const UrlState = {
  COMPLAINT: {authorized: 'complaint', unauthorized: 'complaint-without-login'},
  CONTACT: {authorized: 'contact', unauthorized: 'contact-without-login'},
  SUBCHANGE: {authorized: 'sub-change', unauthorized: 'sub-change-without-login'}
}
